import React from 'react';
import styled from 'styled-components';
import { SAISINE_CAP } from '../../../domain/saisine';

const CapGauge = ({ total = 0, warning = false, large = false }) => {
  const percent = Math.min(100, Math.round((total / SAISINE_CAP) * 100));
  return (
    <GaugeContainer>
      <GaugeTrack $large={large}>
        <GaugeFill $percent={percent} $warning={warning} $large={large} />
      </GaugeTrack>
      <GaugeLabel $warning={warning}>
        {`${total.toLocaleString('fr-FR')} / ${SAISINE_CAP.toLocaleString('fr-FR')} €`}
      </GaugeLabel>
    </GaugeContainer>
  );
};

const GaugeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const GaugeTrack = styled.div`
  flex: 1;
  min-width: 60px;
  height: ${({ $large }) => ($large ? '8px' : '6px')};
  background-color: #ebecf0;
  border-radius: 999px;
  overflow: hidden;
`;

const GaugeFill = styled.div`
  width: ${({ $percent }) => $percent}%;
  height: 100%;
  border-radius: 999px;
  background-color: ${({ $warning }) => ($warning ? '#ff8b00' : '#00875a')};
`;

const GaugeLabel = styled.span`
  font-size: 12px;
  white-space: nowrap;
  color: ${({ $warning }) => ($warning ? '#bf5c00' : '#6b778c')};
`;

export {
  CapGauge,
};
